import {
  IAnswerStats,
  IDropdownOption,
  IOrgAnswerQuestStats,
  IOrgQuestionStats,
  ISurveyAnswer,
  ISurveyDetail,
  ISurveyQuestion,
  ISurveySimple,
} from 'types/interfaces';

export const allowedSurveyIdsList = [1, 9, 10, 11, 12];

export function compareAllSurveysIds(obtainedSurveys: Array<ISurveySimple>) {
  //se obtienen las encuestas que sean de ambito genérico ambitoId 1
  const obtainedSurveysIds = obtainedSurveys
    .filter(
      (survey) =>
        survey.ambitoId === 1 &&
        survey.initDate &&
        new Date() >= new Date(survey.initDate) &&
        survey.isAllowedToAnswer,
    )
    .map((survey) => survey.id);

  const surveyLocal = localStorage.getItem('allSurveys');
  // Comprobamos si hay algún id en los obtenidos que no esté guardado en el localStorage
  if (surveyLocal) {
    const localSurveyIds = JSON.parse(surveyLocal);
    const includeAll = obtainedSurveysIds.every((id) => localSurveyIds.includes(id));
    return !includeAll;
  }

  // Si no hay nada en el localStorage, guardamos y comprobamos si existe alguna encuesta activa de ámbito 1 (genérico)
  localStorage.setItem('allSurveys', JSON.stringify(obtainedSurveysIds));
  return obtainedSurveysIds.length > 0;
}

export function updateNewGenericSurveyIds(obtainedSurveys: Array<ISurveySimple>) {
  const obtainedSurveysIds = obtainedSurveys
    .filter(
      (survey) =>
        survey.ambitoId === 1 && survey.initDate && new Date() >= new Date(survey.initDate),
    )
    .map((survey) => survey.id);
  localStorage.setItem('allSurveys', JSON.stringify(obtainedSurveysIds));
}

export function getSurveyToShowInList(obtainedSurveys: Array<ISurveySimple>) {
  return obtainedSurveys.filter(
    (survey) =>
      allowedSurveyIdsList.includes(survey.ambitoId) &&
      survey.initDate &&
      new Date() >= new Date(survey.initDate),
  );
}

export function getQuestionOptionsDropdown(answer: ISurveyAnswer, t: Function) {
  const options: Array<IDropdownOption> = [];
  options.push({ id: 0, txt: t('lb_elija_una_opcion'), value: '' });
  if (answer.minScaleValue !== null && answer.maxScaleValue !== null) {
    for (let index = answer.minScaleValue; index <= answer.maxScaleValue; index++) {
      options.push({
        id: index,
        txt: index + '',
        value: index,
      });
    }
  }
  return options;
}

export function obtainStructureForm(questions: Array<ISurveyQuestion>) {
  let schema: any = {};

  for (const question of questions) {
    switch (question.typeId) {
      //selección única
      case 1:
        schema[`${question.label}-${question.id}`] = null;
        break;
      //selección múltiple
      case 2:
        schema[`${question.label}-${question.id}`] = null;
        break;
      //valoración (rango numérico)
      case 3:
        for (const answerText of question.answers) {
          schema[`${answerText.label}-${answerText.id}`] = null;
        }
        break;
      //texto corto
      case 4:
        for (const answerText of question.answers) {
          schema[`${answerText.label}-${answerText.id}`] = null;
        }
        break;
      //texto largo
      case 5:
        for (const answerText of question.answers) {
          schema[`${answerText.label}-${answerText.id}`] = null;
        }
        break;
      default:
        break;
    }
  }

  return schema;
}

export function obtainSurveyBody(
  survey: ISurveyDetail,
  schema: any,
  stopId?: number,
  poiId?: number,
  lineId?: number,
  sublineId?: number,
  routeId?: number,
  faqId?: number,
  planId?: string,
) {
  const surveyBody: any = {
    id: survey.id,
    locale: survey.locale,
    stopId: stopId ?? 0,
    poiId: poiId ?? 0,
    lineId: lineId ?? 0,
    sublineId: sublineId ?? 0,
    routeId: routeId ?? 0,
    faqId: faqId ?? 0,
    planId: planId ? planId : null,
  };
  let answers: Array<any> = [];
  console.log('schema', schema);
  console.log('questions:', survey.questions);
  for (const question of survey.questions) {
    switch (question.typeId) {
      //selección única
      case 1:
        // const answer = question.answers.find((answ) => answ.id === schema[`${question.label}-${question.id}`]);
        answers.push({ id: /* answer?.id */schema[`${question.label}-${question.id}`], value: /* answer?.label */ null });
        break;
      //selección múltiple
      case 2:
        for (const val of schema[`${question.label}-${question.id}`]) {
          answers.push({ id: val, value: null });
        }
        break;
      //valoración (rango numérico)
      case 3:
        for (const answerText of question.answers) {
          answers.push(schema[`${answerText.label}-${answerText.id}`]);
        }
        break;
      //texto corto
      case 4:
        for (const answerText of question.answers) {
          answers.push(schema[`${answerText.label}-${answerText.id}`]);
        }
        break;
      //texto largo
      case 5:
        for (const answerText of question.answers) {
          answers.push(schema[`${answerText.label}-${answerText.id}`]);
        }
        break;
      default:
        break;
    }
  }

  surveyBody.answers = answers;
  return surveyBody;
}

export function organizeStatisticsByQuestions(
  stats: Array<IAnswerStats>,
  questionsSurvey: Array<ISurveyQuestion>,
) {
  const organizedStats: Array<IOrgQuestionStats> = [];
  for (const answerStat of stats) {
    //se busca que no esté ya la pregunta en la lista
    const index = organizedStats.findIndex((newOrg) => newOrg.questionId === answerStat.preguntaId);

    const foundQuestion = questionsSurvey.find((question) => question.id === answerStat.preguntaId);

    const answerOrganized: IOrgAnswerQuestStats = {
      answerId: answerStat.respuestaId,
      minScaleValue:
        foundQuestion?.answers.find((answQuest) => answQuest.id === answerStat.respuestaId)
          ?.minScaleValue ?? 0,
      maxScaleValue:
        foundQuestion?.answers.find((answQuest) => answQuest.id === answerStat.respuestaId)
          ?.maxScaleValue ?? 0,
      answerValue: answerStat.value
        ? [
          {
            numValueResponses: answerStat.numValueResponses,
            value: answerStat.value,
          },
        ]
        : [],
      numAnswerResponses: answerStat.numAnswerResponses,
      isValue: answerStat.value ? true : false,
      label: (function getLabel() {
        if (foundQuestion) {
          return (
            foundQuestion.answers.find((answer) => answer.id === answerStat.respuestaId)?.label ??
            ''
          );
        }
        return '';
      })(),
    };

    if (index === -1) {
      //se agrega la nuev pregunta
      organizedStats.push({
        questionId: answerStat.preguntaId,
        answers: [answerOrganized],
        typeId: foundQuestion?.typeId ?? 0,
        label:
          questionsSurvey.find((question) => question.id === answerStat.preguntaId)?.label ?? '',
      });
    } else {
      //caso de tener ya la pregunta, agregamos la respuesta
      if (answerOrganized.isValue) {
        const foundAnswer = organizedStats[index].answers.findIndex(
          (answ) => answ.answerId === answerOrganized.answerId,
        );
        if (foundAnswer === -1) {
          //no existe la respuesta
          organizedStats[index].answers.push(answerOrganized);
        } else {
          //ya existe la respuesta, se agrega el valor
          organizedStats[index].answers[foundAnswer].answerValue.push({
            numValueResponses: answerStat.numValueResponses,
            value: answerStat.value,
          });
        }
      } else {
        organizedStats[index].answers.push(answerOrganized);
      }
    }
  }

  return organizedStats;
}
